import { render, staticRenderFns } from "./DropdownOption.vue?vue&type=template&id=5940baf6&"
import script from "./DropdownOption.vue?vue&type=script&lang=js&"
export * from "./DropdownOption.vue?vue&type=script&lang=js&"
import style0 from "./DropdownOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports